export default function Footer(props){
	return (
		<div className="footer">
			&copy;{props.year} Casey Moir, All Rights Reserved. - Designed by: Brenton Petrasich
		</div>
	);
}